// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2BcD6","question":"styles_question__1EIiL","inputVisibleButton":"styles_inputVisibleButton__UnBeq","note":"styles_note__3l2OM"};